// extracted by mini-css-extract-plugin
module.exports = {"AddAccount":"PortalForm_AddAccount_pF2j7","FormTitle":"PortalForm_FormTitle_iocbS","Message":"PortalForm_Message_mUsLB","Cancel":"PortalForm_Cancel_YsZAO"};